import type { IconSvgObject } from './types';

const EclipseIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12.002", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3.00195C12.0537 3.55988 9 7.3766 9 12.002C9 16.6273 12.0537 20.444 16 21.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EclipseIcon;
